import { render, staticRenderFns } from "./livingPreviewer.vue?vue&type=template&id=6c0f2d8a&scoped=true"
import script from "./livingPreviewer.vue?vue&type=script&lang=js"
export * from "./livingPreviewer.vue?vue&type=script&lang=js"
import style0 from "./livingPreviewer.vue?vue&type=style&index=0&id=6c0f2d8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f2d8a",
  null
  
)

export default component.exports